module.exports = __webpack_public_path__ + "public/img/chanliang_2.7a50e3ac.png";